import { z } from "zod";
//#region src/api/orpc/image/enums.ts
/**
* Aspect ratios accepted by `POST /image/create`.
*
* Each value maps deterministically to a concrete `{width, height}` pair via
* `resolveResolution(aspectRatio, size)` (see `./resolution`). Keep this
* enum in sync with `RESOLUTION_MAP` — adding a ratio here without adding a
* resolution entry will surface as a typescript error.
*/
const AspectRatio = z.enum([
	"1:1",
	"3:4",
	"4:3",
	"3:5",
	"5:3",
	"9:16",
	"16:9",
	"1:3",
	"3:1"
]);
/**
* Output size buckets. Only `1k` is offered today; higher tiers will be
* appended here (and `RESOLUTION_MAP` extended in lockstep).
*/
const ImageSize = z.enum(["1k"]);
/**
* Inference quality tier. Names match the server-side inference profile
* identifiers 1:1 (see `resolveInferenceProfile`).
*/
const GenerationMode = z.enum([
	"lite",
	"standard",
	"pro",
	"ultra"
]);
/**
* Curated style presets. Picked when the user opts for a built-in look via
* `{ type: 'preset', key }`. Custom free-form styles use the `custom`
* branch of `StyleSchema` instead.
*/
const StylePresetKey = z.enum([
	"anime-watercolor-impasto",
	"art-crayon",
	"bold-line-soft-color",
	"chibi",
	"classic-japanese",
	"clean-flat-illustration",
	"colored-pencil-grain",
	"cool-warm-oil-contrast",
	"desaturated-cool",
	"flat-anime-pastel",
	"glossy-glass-anime",
	"grey-blocks-lineless",
	"hard-line-monochrome-accent",
	"high-contrast-retro-vivid",
	"holographic",
	"korean-style",
	"lineart-watercolor-airy",
	"low-saturation-expressive-eyes",
	"lucid-dreamy",
	"luminous-retro-impasto",
	"minimal-flat-color",
	"modern-oil-glamour",
	"moe-pastel",
	"oil-watercolor-blend",
	"painterly-doodle",
	"paper-watercolor",
	"pencil-sketch",
	"poster-graffiti",
	"retro-comic-fusion",
	"retro-oil-glamour",
	"retro-tv-anime",
	"semi-realistic",
	"stable-vaporwave",
	"tinted-sketch",
	"vintage-collage"
]);
//#endregion
export { AspectRatio, GenerationMode, ImageSize, StylePresetKey };
